import React, { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  Container,
  Grid,
  InputAdornment,
  IconButton,
  InputLabel,
} from "@mui/material";
import Controls from "../components/FormsUI";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../utility/auth";
import LoginController from "../controller/LoginController";
import CustomizedSnackbars from "../components/Alert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Logo from "../assets/images/logo.png";
import "../css/style.css";
import ExceptionHandlerController from "../controller/ErrorLogsController";
import { ENCRYPTION_TYPE, EncryptDecrypt } from "../utility/encryption";

const INITIAL_FORM_STATE = { username: "", password: "" };
const FORM_VALIDATION = Yup.object().shape({
  username: Yup.string()
    .email()
    .trim("No white space allowed")
    .strict(true)
    .required("Email Id is required"),
  password: Yup.string()
    .trim("No white space allowed")
    .min(8)
    .strict(true)
    .required("Password is required"),
});
const apiMessages = {
  NO_PAYMENT_DONE: "Please register again and submit your payment details.",
  SUSPENDED:
    "Your account has been temporarily disconnected. Kindly contact the administrator.",
};
const loginController = new LoginController();
const exceptionHandlerController = new ExceptionHandlerController();
const getDate = () => {
  let caughtError;
  try {
    return (
      "" +
      (new Date()?.getDate()?.toString()?.length === 1
        ? "0" + new Date()?.getDate()
        : new Date()?.getDate()) +
      "/" +
      (Number(new Date()?.getMonth() + 1)?.toString()?.length === 1
        ? "0" + Number(new Date()?.getMonth() + 1)
        : Number(new Date()?.getMonth() + 1)) +
      "/" +
      new Date()?.getFullYear() +
      "  " +
      new Date()?.toLocaleTimeString()
    );
  } catch (error) {
    caughtError = error;
    let logData = {};
    logData.message = caughtError?.message;
    logData.stack = caughtError?.stack;
    let logError = { logData, module: "Login getdate method" };
    exceptionHandlerController.HandleException(logError);
  }
};
// const Login = ({ setRole }) => {
const Login = ({ setRole, setAccessRoutes }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const auth = useAuth();
  const [alert, setAlert] = useState({ counter: 0, type: "", msg: "" });
  const [IP, setIP] = useState("");
  const [togglePassword, setTogglePassword] = useState(true);
  const [access, setAccess] = useState([]);
  let redirectPath = "/";
  if (
    location?.state === null ||
    location?.state?.path === "" ||
    location?.state?.path === "/"
  )
    redirectPath = "/profile";
  else redirectPath = location?.state?.path;

  const showAlert = (type, msg) => {
    const notify = { ...alert };
    notify.counter = notify?.counter + 1;
    notify.type = type;
    notify.msg = msg;
    setAlert(notify);
  };

  React.useEffect(() => {
    async function ipAddress() {
      await fetch("https://api.ipify.org/?format=json")
        .then((response) => response?.json())
        .then((data) => setIP(() => data?.ip))
        .catch((error) => console.error("error", error));
    }
    ipAddress();
  }, []);
  const handleLogin = (data) => {
    try {
      prepareLoginData(data);
      loginController
        .Login(data)
        .then(handleLoginResponse)
        .catch(() => {
          showAlert("error", "Oops something went wrong.");
        });
    } catch (error) {
      logError(error, "Login method");
    }
  };

  const prepareLoginData = (data) => {
    data.IP = IP;
    data.LastLoginDateTime = getDate();
  };

  const handleLoginResponse = (response) => {
    // debugger
    if (response?.status === 200) {
      handleSuccessResponse(response);
    } else {
      handleErrorResponse(response);
    }
  };
  const getFirstAccessiblePath = (access) => {
    for (const menu of access) {
      if (menu?.subMenus?.length > 0) {
        return menu.subMenus[0]?.path; // return first submenu
      } else if (menu?.path) {
        return menu.path; // fallback to main menu path
      }
    }
    return "/not-found"; // default fallback
  };

  const handleSuccessResponse = async (response) => {
    // debugger
    const message = response?.data?.message;
    if (
      message === apiMessages?.NO_PAYMENT_DONE ||
      message === apiMessages?.SUSPENDED
    ) {
      showAlert("info", message);
      return;
    }
    let tokenData;
    const decryptedData = decryptData(response?.data?.body);
    if (decryptedData?.token) {
      tokenData = decryptedData?.token;
      auth?.login(decryptedData?.token);
      const user = auth?.decoder(decryptedData?.token);

      // const setAccessRole = async () => {
      try {
        // debugger
        const accessRoleResponse = await loginController.getMenu(tokenData);
        setAccess(accessRoleResponse?.data?.body?.access || []);
        sessionStorage.setItem("accessRole", JSON.stringify(accessRoleResponse?.data?.body?.access));
        // const ad = sessionStorage.getItem("accessRole")

      } catch (err) {
        console.error("Failed to load access", err);
      }
      // }
      if (user) {
        finalizeLogin(user, decryptedData);
      }
    }
  };

  const decryptData = (data) => {
    return Object.keys(data || {}).length !== 0
      ? EncryptDecrypt(data, ENCRYPTION_TYPE?.DECRYPT)
      : data;
  };


  const finalizeLogin = async (user, decryptedData) => {
    const role = user?.data?.UserInfo?.role;
    setRole(role);
    sessionStorage.setItem("LastLogin", decryptedData?.lastLogin);
    sessionStorage.setItem("TenantName", decryptedData?.tenantName);
    showAlert("success", "Login Successfully");

    // -   const access = JSON.parse(sessionStorage.getItem("accessRole") || "[]");
    // -   let redirectPath;
    // -   if (role === "SUPER ADMIN") {
    // -     redirectPath = "/create-tenant";
    // -   } else {
    // -     const hasProfileAccess = access.some(menu =>
    // -       menu.subMenus.some(sub => sub.path === "/profile")
    // -     );
    // -     redirectPath = hasProfileAccess ? "/profile" : await getFirstAccessiblePath(access);
    // -   }
    // -   navigate(redirectPath, { state: { data: null } });
    const access = JSON.parse(sessionStorage.getItem("accessRole") || "[]");

    // 🔹 Flatten routes for App.js
    const flatRoutes = access.flatMap((menuGroup) =>
      menuGroup.subMenus.map((sub) => ({
        path: sub.path,
        componentName: sub.component,
      }))
    );
    sessionStorage.setItem("accessRoutes", JSON.stringify(flatRoutes));
    setAccessRoutes(flatRoutes);

    // 🔹 Redirect logic (same as before)
    let redirectPath;
    if (role === "SUPER ADMIN") {
      redirectPath = "/create-tenant";
    } else {
      const hasProfileAccess = access.some((menu) =>
        menu.subMenus.some((sub) => sub.path === "/profile")
      );
      redirectPath = hasProfileAccess ? "/profile" : await getFirstAccessiblePath(access);
    }
    navigate(redirectPath, { state: { data: null } });
  };

  const handleErrorResponse = (response) => {
    const status = response?.response?.status;
    const message = response?.response?.data?.message;

    if (status === 400 || status === 500) {
      showAlert("error", message);
    }
  };

  const logError = (error, module) => {
    const logData = {
      message: error?.message,
      stack: error?.stack,
    };
    const logErrorLogin = { logData, module };
    exceptionHandlerController.HandleException(logErrorLogin);
  };

  return (
    <Grid container>
      <Grid item xs={12} className="loginlogo">
        <img src={Logo} alt="Logo" />
      </Grid>
      <Grid item xs={12} className="login-bg">
        <Container maxWidth="md">
          <div>
            <Formik
              initialValues={{ ...INITIAL_FORM_STATE }}
              validationSchema={FORM_VALIDATION}
              onSubmit={(values) => handleLogin(values)}
            >
              {({ handleSubmit }) => (
                <Form>
                  <Grid container spacing={2} className="page-container">
                    <Grid item xs={12}>
                      <Grid className="heading">
                        <h3>Login</h3>
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <Controls.Textfield
                        name="username"
                        label="Email Id"
                        type="string"
                        inputProps={{ maxLength: 50 }}
                        autoFocus
                        onKeyDown={(e) => {
                          if (e.keyCode === 13) handleSubmit(e);
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Controls.Textfield
                        name="password"
                        label="Password"
                        type={togglePassword ? "password" : "string"}
                        inputProps={{ maxLength: 50 }}
                        onKeyDown={(e) => {
                          if (e.keyCode === 13) handleSubmit(e);
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() =>
                                  setTogglePassword((toggle) => !toggle)
                                }
                              >
                                {togglePassword && <VisibilityIcon />}
                                {!togglePassword && <VisibilityOffIcon />}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    {location?.state?.data === "expired" ? (
                      <InputLabel
                        className="infotext infonominee mob-ipvsvg"
                        sx={{
                          color: "#d32f2f",
                          font: "inherit",
                          paddingLeft: "10px",
                        }}
                      >
                        Your session was expired. Please login again
                      </InputLabel>
                    ) : null}
                    <Grid item xs={12}>
                      <Controls.Button>Login</Controls.Button>
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>
            {alert.counter > 0 && (
              <CustomizedSnackbars
                status={alert.counter}
                msg={alert.msg}
                type={alert.type}
              />
            )}
          </div>
        </Container>
      </Grid>
    </Grid>
  );
};

export default Login;
